<template>
  <div>
    <SpecificBrowserSelector
      v-for="(browser, index) in modelValue"
      :key="index"
      :browser="browser"
      :index="index"
      :available-browsers="availableBrowsers"
      @update="updateSpecific"
      @remove="removeSpecific"
    />
    <el-button
      v-if="availableBrowsers.length > 0"
      size="small"
      @click.prevent="addSpecificBrowser"
    >
      Add
    </el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import SpecificBrowserSelector from './SpecificBrowserSelector.vue'
import { Browser, BrowserKey, SpecificVersion } from '@/api/types'

export default defineComponent({
  name: 'SpecificBrowsersSelector',
  components: {
    SpecificBrowserSelector
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const specifiedBrowsers = computed<Browser[]>(() => {
      return (props.modelValue as Array<SpecificVersion<Browser>>).map(
        (specificBrowser: SpecificVersion<Browser>) => specificBrowser.id
      )
    })

    const availableBrowsers = computed<Browser[]>(() => {
      const result: Browser[] = []
      for (const browser in Browser) {
        const browserId = Browser[browser as BrowserKey]
        if (specifiedBrowsers.value.indexOf(browserId as Browser) < 0) {
          result.push(browserId as Browser)
        }
      }
      return result
    })

    function addSpecificBrowser() {
      if (availableBrowsers.value.length === 0) {
        return
      }
      const newSpecific: SpecificVersion<Browser> = {
        id: availableBrowsers.value[0],
        comparison: '>',
        version: '1.0.0'
      }
      context.emit('update:modelValue', props.modelValue.concat(newSpecific))
    }

    function updateSpecific(payload: {
      index: number
      specific: SpecificVersion<Browser>
    }) {
      // Copy props, and they update, to avoid weird issues with reactivity
      const updatedSpecifics = props.modelValue.slice(0)
      updatedSpecifics[payload.index] = payload.specific
      context.emit('update:modelValue', updatedSpecifics)
    }

    function removeSpecific(index: number) {
      const removed = props.modelValue.filter((_, i) => i !== index)
      context.emit('update:modelValue', removed)
    }

    return {
      addSpecificBrowser,
      specifiedBrowsers,
      availableBrowsers,
      updateSpecific,
      removeSpecific
    }
  }
})
</script>
